import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, MapPin, Trophy } from 'lucide-react';
import { useUserTournaments } from '@/hooks/useUserTournaments';

interface TournamentListDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TournamentListDialog({ open, onOpenChange }: TournamentListDialogProps) {
  const { tournaments, loading } = useUserTournaments();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-yellow-600" />
            Torneos Participados
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          {loading ? (
            <div className="text-center py-8">Cargando torneos...</div>
          ) : tournaments && tournaments.length > 0 ? (
            tournaments.map((tournament) => (
              <Card key={tournament.id} className="hover:shadow-md transition-shadow">
                <CardContent className="p-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-900 mb-2">{tournament.title}</h3>
                      <div className="flex items-center gap-4 text-sm text-gray-600 mb-2">
                        <div className="flex items-center gap-1">
                          <Calendar className="h-4 w-4" />
                          {new Date(tournament.start_date).toLocaleDateString()}
                        </div>
                        <div className="flex items-center gap-1">
                          <MapPin className="h-4 w-4" />
                          {tournament.location}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <Badge variant="outline">{tournament.sport}</Badge>
                        <Badge variant={tournament.status === 'completed' ? 'default' : 'secondary'}>
                          {tournament.status === 'completed' ? 'Completado' : tournament.status === 'active' ? 'En curso' : 'Próximo'}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))
          ) : (
            <div className="text-center py-8 text-gray-500">
              No has participado en ningún torneo aún
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}